function normalizer(data) {
    const output = Object.assign({}, data);

    return output;
}

function prepareForEdit(data) {
    // tags 
    data.tag = data.tags.map(tag => {return {key: tag.id, label: tag.title}});
    
    return data;
}

export {
    normalizer,
    prepareForEdit
}


// WEBPACK FOOTER //
// ./src/containers/Events/pipeline.js